export const ADD_NEEDS = "ADD_NEEDS";
export const ADD_NEWS = "ADD_NEWS";
export const DELETE_RESOURCE = "DELETE_RESOURCE";
